var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('input',{staticStyle:{"float":"left","display":"none"},attrs:{"type":"file","id":"uploadFile2","accept":"image/*","capture":"camera"},on:{"change":_vm.readLocalFile}})])}
var staticRenderFns = []

export { render, staticRenderFns }